module.exports = __webpack_public_path__ + "static/img/holland-picture1.a2ba3d87.jpg";